export enum ProcessType {
    PhoneRegisterConfirmation = 1,
}

export enum PhoneConfirmationWay {
    sms = 1,
    flashCall = 2,
    email = 3,
    push = 4,
    userCall = 6,
}

export enum PhoneVerifyStateId {
    success = 3,
}

export const MinPhoneLength = 10;
